import { styled } from 'linaria/react';
import React from 'react';
import { useIntl } from '@jetshop/intl';
import { useNewsletterSubscription } from '@jetshop/core/hooks/Subscriptions/useNewsletterSubscription';
import { theme } from '../Theming/Theming';

const FieldErrorWrapper = styled('div')``;

const Wrapper = styled('div')`
  position: relative;
  width: 100%;
  background: transparent;
  height: 4rem;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  flex: 0 1 20rem;
  form,
  input {
    height: 100%;
    width: 100%;
  }
  form {
    display: flex;
    gap: 1rem;
  }

  input {
    background: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    border: none;
  }
  label {
    position: absolute;
    font-size: 0.75rem;
    left: calc(0.5rem + 1px);
    top: -6px;
    background: white;
    padding: 0 0.5rem;
  }
  button {
    color: ${theme.footer.newsletterButton.color};
    background: ${theme.footer.newsletterButton.background};
    border: ${theme.footer.newsletterButton.border};
    width: 50%;
    padding: 0 2rem;
    outline: none;
    height: 100%;
    cursor: pointer;
    &:disabled {
      opacity: 0.5;
    }
  }
  > p {
    color: ${theme.colors.font};
  }
`;

const Error = styled('div')`
  margin-bottom: 0.5rem;
  color: #650e1b;
`;

function NewsletterField() {
  const {
    inputProps,
    submit,
    submitting,
    submitted,
    failed,
    errorStates: { alreadySubscribed, invalidEmail }
  } = useNewsletterSubscription({
    enabled: true
  });

  const t = useIntl();
  const disabled = inputProps.value.length === 0 || submitting;

  return (
    <FieldErrorWrapper className="newsletter-fields-wrapper">
      <Error>
        {alreadySubscribed &&
          t('You have already subscribed to the newsletter!')}
        {invalidEmail || failed
          ? t('Something went wrong. Please check your email and try again.')
          : null}
      </Error>
      <Wrapper>
        {submitted ? (
          <p data-testid="newsletter-subscription-success">
            {t('You are now subscribed')}
          </p>
        ) : (
          <form onSubmit={submit} disabled={disabled}>
            <input
              type="email"
              id="newsletter"
              placeholder={t('Enter email address')}
              data-testid="newsletter-subscription-input"
              {...inputProps}
            />
            <button
              className="button"
              type="submit"
              disabled={disabled}
              data-testid="newsletter-subscription-submit"
            >
              {submitting ? t('Submitting…') : t('Submit')}
            </button>
          </form>
        )}
      </Wrapper>
    </FieldErrorWrapper>
  );
}

export default NewsletterField;
